import logo from '@/assets/brand/logo.png'

export function FullScreenLoader() {
  return <div className="fixed inset-0 z-[100] grid place-items-center bg-white/88 backdrop-blur-sm" role="status" aria-live="polite">
    <img className="h-16 w-16 object-contain opacity-35" src={logo} alt="" aria-hidden="true" />
    <span className="sr-only">Đang tải</span>
  </div>
}
